import VLabel from './VLabel'

export { VLabel }
export default VLabel



// WEBPACK FOOTER //
// ../../../src/components/VLabel/index.ts